import React from 'react';
import styled from 'styled-components';
import {Avatar, message} from 'antd';
import {Twitter} from '@styled-icons/fa-brands/Twitter';
import {Twitch} from '@styled-icons/fa-brands/Twitch';
import {Instagram} from '@styled-icons/fa-brands/Instagram';
import {Facebook} from '@styled-icons/boxicons-logos/Facebook';
import {Desktop} from '@styled-icons/fa-solid/Desktop';
import {Share} from '@styled-icons/bootstrap/Share';
import useArtist from '../../Hooks/useArtist';
import * as AppActions from '../../AppActions';

const ArtistInfo = (props) => {
  const {artist} = useArtist(props.artist);

  const [total, setTotal] = React.useState(0);

  async function copyProductShareUrl() {
    let _url = AppActions.getReurl({
      title: encodeURIComponent(artist.collection.name),
      image: artist.og_image || '',
      redirectUrl: `${window.location.origin}/products?q=${artist.id}`,
    });
    try {
      await navigator.clipboard.writeText(_url);
      message.success(`已複製分享連結`);
    } catch (err) {
      console.log(err);
      message.warn(`無法複製連結`);
    }
  }

  React.useEffect(() => {
    const fetch = async () => {
      if (!artist) {
        return;
      }
      try {
        AppActions.setLoading(true);
        let resp = await AppActions.clientJStorageFetch('product', {
          cat: artist.name,
        });

        const {total} = resp;
        setTotal(total);
      } catch (e) {
        setTotal(0);
      } finally {
        AppActions.setLoading(false);
      }
    };
    fetch();
  }, [artist]);

  const links = React.useMemo(() => {
    if (!artist) {
      return [];
    }
    return [
      {
        icon: <Desktop />,
        link: artist.link_official_website,
      },
      {
        icon: <Instagram />,
        link: artist.link_instagram,
      },
      {
        icon: <Twitch />,
        link: artist.link_twitch,
      },
      {
        icon: <Twitter />,
        link: artist.link_twitter,
      },
      {
        icon: <Facebook />,
        link: artist.link_facebook,
      },
      {
        icon: <Share />,
        link: async () => {
          await copyProductShareUrl();
        },
      },
    ];
  }, [artist, copyProductShareUrl]);

  if (!artist) {
    return <StyledArtistSection />;
  }

  return (
    <StyledArtistSection>
      <Avatar size={130} src={artist.images[0].expected_url} />
      <h1>{artist.collection.name}</h1>
      <div className="link-group">
        {links.map((l, i) => (
          <div
            className="link"
            key={i}
            onClick={async () => {
              if (typeof l.link === 'function') {
                await l.link();
                return;
              }
              if (l.link) {
                window.open(l.link, '_blank');
              } else {
                message.warning('目前沒有此連結');
              }
            }}>
            {l.icon}
          </div>
        ))}
      </div>
      <div className="product-counts">
        <div className="count">{total}</div>
        <div className="label">Items</div>
      </div>
    </StyledArtistSection>
  );
};

const StyledArtistSection = styled.div`
  width: 100%;
  height: 370px;
  min-height: 370px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid rgba(125, 131, 139, 0.64);
  margin-bottom: 55px;
  & > h1 {
    text-align: center;
  }
  & > .link-group {
    display: flex;
    flex-direction: row;
    & > .link {
      width: 30px;
      height: 30px;
      padding: 5px;
      margin: 0 5px;
      transition: all 300ms ease;
      transform: scale(1);
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
    }
  }
  & > .product-counts {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: var(--snow-owl-theme-font-color);
    & > .count {
      font-size: 18px;
      letter-spacing: 0.63px;
      text-align: center;
      line-height: 20px;
      font-weight: 900;
    }
    & > .label {
      font-size: 12px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
`;

export default ArtistInfo;
